require('./brokerNewsView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @utils
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const BrokerNewsColumn = require('components/commons/broker/news/brokerNewsColumn');
const MarketPulseNews = require('components/commons/broker/news/marketPulseNews');
// @ actions
const newsActions = require('actions/brokerNews');
const marketPulsesActions = require('actions/brokerMarketPulses');
// @ constants
const {
    BROKER_NEWS_LIMIT,
    MYPROFILE_BROKER_URL
} = require('constants/index');

class BrokerNewsView extends React.Component {

    componentDidMount() {
        scrollToTop();
    }

    render() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerNews'),
                url: ''
            }
        ];

        // @hardcoded
        const titleColumnLeftText = 'Últimas noticias';
        const titleColumnRightText = 'Pulsos de mercado';

        return (
            <div>
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('broker-brokerNews')}
                    />
                </OKCover>
                <section className="broker-news-view">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <ContentBox title={titleColumnLeftText} smallTitle={true}>
                                <div className="news-underline" />
                                <BrokerNewsColumn
                                    immBrokerNews={this.props.immBrokerNews}
                                    requestNews={this.props.requestNews}
                                    maxNews={BROKER_NEWS_LIMIT}
                                    width="col-lg-12"
                                    newsSection={true}
                                    hasTime={true}
                                />
                            </ContentBox>
                        </div>
                        <div className="col-xs-4">
                            <ContentBox title={titleColumnRightText} smallTitle={false}>
                                <MarketPulseNews
                                    requestMarketPulses={this.props.requestMarketPulses}
                                    immMarketsPulses={this.props.immMarketsPulses}
                                    newsSection={true}
                                />
                            </ContentBox>
                        </div>
                    </div>
                    <div className="row no-outside-gutter">
                        <div className="col-lg-12 broker-news-view__footer-disclaimer">
                            <div className="broker-news-view__disclaimer-paragraph">
                                <FormattedText value="broker-disclaimerTextFirstParagraph" />
                            </div>
                            <div className="broker-news-view__disclaimer-paragraph">
                                <FormattedText value="broker-disclaimerTextSecondParagraph" />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerNewsView.propTypes = {
    immBrokerNews: PropTypes.object,
    requestNews: PropTypes.func.isRequired,
    requestMarketPulses: PropTypes.func.isRequired,
    immMarketsPulses: PropTypes.object.isRequired
};

module.exports.constructor = BrokerNewsView;
module.exports.BrokerNewsView = connect(
    state => ({
        immBrokerNews: state.brokerNews,
        immMarketsPulses: state.brokerMarketsPulses
    }),
    {
        requestNews: newsActions.requestNews,
        requestMarketPulses: marketPulsesActions.requestMarketPulses
    }
)(BrokerNewsView);
